import { render, staticRenderFns } from "./TacticsBoardPositionName.vue?vue&type=template&id=cf25a442&scoped=true"
import script from "./TacticsBoardPositionName.vue?vue&type=script&lang=js"
export * from "./TacticsBoardPositionName.vue?vue&type=script&lang=js"
import style0 from "./TacticsBoardPositionName.vue?vue&type=style&index=0&id=cf25a442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf25a442",
  null
  
)

export default component.exports